export interface UseAddressQueries {
    searchAddresses(query: string, setOptions: React.Dispatch<React.SetStateAction<string[]>>): Promise<void>
}

export function useAddressQueries(getAutocompleteService: () => google.maps.places.AutocompleteService): UseAddressQueries {
    
    const searchAddresses = async (query: string, setOptions: React.Dispatch<React.SetStateAction<string[]>>): Promise<void> => {
        const autocompleteService = getAutocompleteService()
            
        if (!autocompleteService) {
            setOptions([])
        }

        try {
            autocompleteService.getPlacePredictions({ input: query, types: [] }, (predictions: google.maps.places.AutocompletePrediction[], status) => {
                if (status === 'OK' && predictions) {
                    const suggettions: string[] = predictions.map(prediction => prediction.description);

                    setOptions(suggettions)
                } else {
                    setOptions([]);
                }
            });
        } catch (e) {
            setOptions([])
        }
    }

    return { searchAddresses }
}